import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { AdminFeatureRoutingModule } from "./admin-feature-routing.module";
import { SharedService } from "../../modules/shared/services/shared.service";
import { LocalDataService } from "../../modules/shared/services/local-data.service";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AccountService } from "../../modules/shared/services/account.service";
import { EventService } from "../../modules/shared/services/event.service";
import { CatalogService } from "../../modules/shared/services/catalog.service";
import { SessionService } from "../../modules/shared/services/session-service";
import { FlashMessagesModule } from "angular2-flash-messages";
import { SharedModule } from "../shared-module/shared-module";
import { NgxFitTextModule } from "ngx-fit-text";

import {
    AdminFeatureView,
    CatalogContextView,
    SettingPageView,
    DefaultSetupView,
    ThemePageView,
    ThemeConfigView,
    ElementPageView,
    LayoutPageView,
    HeaderPageView,
    HtmlPageView,
    SpeakerPageView,
    TemplateConfigView,
    ImageConfigView,
    RegionConfigView,
    HtmlConfigView,
    LabelConfigView,
    SpeakerSessionsPageView,
    SpeakerBioPageView,
    TabsPageView,
    TabConfigView,
    DataPageView,
    GeneralPageView,
    HighlightedPageView,
    GroupingCustomizeDisplaySectionView,
    ListService,
    DefaultDrawerView,
    DefaultPopupView,
    SessionConfigView,
    AdditionalSettingPageView,
    ButtonConfigView,
    SettingView
} from ".";
import {
    CclListModule,
    CclNavigationModule,
    CclSharedModule,
    CclLayoutModule,
    CclPageBuilderModule,
    CclPaletteModule,
    CclTemplateResolverService,
    CclNavbarSecondaryService,
    CclBuilderService,
    CclFormsModule,
    CclMessageService,
    CclQuestionBuilderModule
} from "certain-common-library";
import { AttendeeSessionService } from "../../modules/shared/services/attendee-session.service";
import { SpeakerService } from "../../modules/shared/services/speaker.service";
import { UploadService } from "../../modules/shared/services/upload.service";
import { CanDeactivateGuard } from "./can-deactivate";
import { AceEditorModule } from 'ng2-ace-editor';
import { GainSightService } from "../../modules/shared/services/gainsight.service";

@NgModule({
    declarations: [
        AdminFeatureView,
        CatalogContextView,
        SettingPageView,
        DefaultSetupView,
        ThemePageView,
        ThemeConfigView,
        ElementPageView,
        LayoutPageView,
        HeaderPageView,
        HtmlPageView,
        SpeakerPageView,
        TemplateConfigView,
        ImageConfigView,
        RegionConfigView,
        HtmlConfigView,
        LabelConfigView,
        SpeakerSessionsPageView,
        SpeakerBioPageView,
        TabsPageView,
        TabConfigView,
        DataPageView,
        GeneralPageView,
        HighlightedPageView,
        GroupingCustomizeDisplaySectionView,
        DefaultDrawerView,
        DefaultPopupView,
        SessionConfigView,
        AdditionalSettingPageView,
        ButtonConfigView,
        SettingView
    ],
    imports: [
        AdminFeatureRoutingModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        NgbModule,
        CclListModule,
        CclNavigationModule,
        CclSharedModule,
        CclLayoutModule,
        CclPageBuilderModule,
        CclPaletteModule,
        CclFormsModule,
        CclQuestionBuilderModule,
        FlashMessagesModule.forRoot(),
        SharedModule,
        NgxFitTextModule.forRoot(),
        AceEditorModule
    ],
    providers: [
        CclTemplateResolverService,
        CclNavbarSecondaryService,
        CclBuilderService,
        CclMessageService,
        ListService,
        SharedService,
        LocalDataService,
        AccountService,
        EventService,
        CatalogService,
        SessionService,
        AttendeeSessionService,
        UploadService,
        CanDeactivateGuard,
        SpeakerService,
        GainSightService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AdminFeatureModule {}
